import { ImageOff } from "lucide-react";
import { useState } from "react";

/**
 * Media with a graceful fallback: renders a placeholder tile instead of a
 * broken-image glyph when the file is missing or fails to load.
 */
export default function SafeImage({
  src,
  alt,
  className,
  loading = "lazy",
}: {
  src: string;
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
}) {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return (
      <div
        className={`${className ?? ""} flex items-center justify-center bg-secondary/60`}
        role="img"
        aria-label={alt}
      >
        <ImageOff className="w-6 h-6 text-muted-foreground/60" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      onError={() => setFailed(true)}
    />
  );
}
